<a class="skip-link" href="#main-content">Skip to content</a>
<div class="app-shell">
  <mkzs-header
    (signInRequested)="signIn()"
    (signOutRequested)="signOut()"
  />

  @if (authService.lastError(); as authError) {
    <section class="auth-error" role="alert">
      {{ authError }}
    </section>
  }

  <main id="main-content" class="content-shell">
    <router-outlet />
  </main>

  <mkzs-cookie-banner />

  <mkzs-footer />
</div>
